export default __webpack_public_path__ + "static/avatar-james-48e7371fd52c5d4ee73a686907e53d57.jpg";